if (!customElements.get('form-builder')) {
  class FormBuilder extends HTMLElement {
    constructor() {
      super();
      this.onChange = this.onChange.bind(this);
      this.onSubmit = this.onSubmit.bind(this);
    }

    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;

      this.groups = Array.from(this.form.querySelectorAll('[data-required-group]'));
      this.groups.forEach((group) => this.validateGroup(group));

      this.form.addEventListener('change', this.onChange);
      this.form.addEventListener('submit', this.onSubmit);

      const success = this.querySelector('.form-builder__success');
      if (success) success.focus();
    }

    disconnectedCallback() {
      if (!this.form) return;
      this.form.removeEventListener('change', this.onChange);
      this.form.removeEventListener('submit', this.onSubmit);
    }

    // Native validation can't require "at least one" checkbox in a group,
    // so put a custom validity on the first checkbox until one is checked.
    validateGroup(group) {
      const boxes = group.querySelectorAll('input[type="checkbox"]');
      if (!boxes.length) return;
      const anyChecked = Array.from(boxes).some((box) => box.checked);
      boxes[0].setCustomValidity(anyChecked ? '' : group.dataset.errorMessage || 'Please select at least one option.');
    }

    onChange(event) {
      const group = event.target.closest('[data-required-group]');
      if (group) this.validateGroup(group);
    }

    onSubmit() {
      // Only fires when the form is valid; prevent double submits.
      const button = this.form.querySelector('[type="submit"]');
      if (button) button.setAttribute('aria-busy', 'true');
    }
  }

  customElements.define('form-builder', FormBuilder);
}
